/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Error from './Error/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AppAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Launchers/Content/App/AppAction",
  onSubmit,
  disabled
  
}) {
let launcherSubmitData = fromData.useDataSubmit({ viewPath,
context: 'launcher',
})
let launcherNameValueData = fromData.useDataValue({ viewPath,
context: 'launcher',
path: 'name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 width="100%"
 data="launcher"
 onClick={launcherSubmitData}
 disabled={disabled}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Error
{...childProps}
  viewPath={`${viewPath}/Error`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="launcher.name"
 text={launcherNameValueData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}